// Configuration API
const config = {
  // URL de l'API backend (proxy par nginx)
  API_BASE_URL: '/api',  // Proxifié par nginx vers le backend
    
  // Configuration de l'application
  APP_NAME: 'Instagram Team',
  VERSION: '2.0.0'
};

export default config;
